// Shared-passphrase gate: shown instead of the app whenever the server
// answers 401 auth_required (public deployments set ACCESS_PASSPHRASE).
// Success sets an HttpOnly cookie server-side, so there is nothing to store
// here — the store flips authRequired and the app renders normally.

import { useState, type FormEvent } from 'react';
import { useStore } from '../store/useStore.ts';

export function PassphraseScreen() {
  const submitPassphrase = useStore((s) => s.submitPassphrase);
  const [passphrase, setPassphrase] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(event: FormEvent) {
    event.preventDefault();
    if (busy || passphrase.length === 0) return;
    setBusy(true);
    setError(null);
    const failure = await submitPassphrase(passphrase);
    if (failure !== null) {
      setError(failure);
      setBusy(false);
    }
    // On success authRequired flips false and this screen unmounts.
  }

  return (
    <main className="setup-screen">
      <div className="setup-card">
        <h1 className="setup-title">A private board.</h1>
        <p className="setup-sub">This table is set for invited guests — the passphrase, please.</p>
        <form className="pass-form" onSubmit={(event) => void onSubmit(event)}>
          <input
            type="password"
            className="pass-input"
            value={passphrase}
            onChange={(event) => setPassphrase(event.target.value)}
            aria-label="Passphrase"
            autoComplete="current-password"
            autoFocus
          />
          <button
            type="submit"
            className="btn btn-accent"
            disabled={busy || passphrase.length === 0}
          >
            {busy ? 'Checking…' : 'Enter'}
          </button>
        </form>
        {error !== null && (
          <p className="form-error" role="alert">
            {error}
          </p>
        )}
      </div>
    </main>
  );
}
